/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_MY_COMMITTE_INVITE_STATUS = gql`
query GetMyCommitteInviteStatus {
  getMyCommitteInviteStatus {
    content {
      referalsUsed
      inviteType
      id
      maxInvites
      partition
      presentation {
        country
        createdAt
        id
        name
        sections {
          id
          description
          createdAt
          name
        }
        status
        updatedAt
        year
      }
      sections {
        id
        name
      }
      sectionOptType
      purchased
      user {
        id
        emailVerified
        email
      }
    }
    count
    limit
    skip
  }
}
`;
